<template>
  <div class="pwmat-introduce-background">
    <div class="pwmat-introduce-banner">
      <div class="pwmat-introduce-container">
        <div class="pwmat-introduce-banner-title">PWMLFF</div>
      </div>

      <img
        class="pwmat-introduce-banner-img"
        src="../../assets/about/banner.png"
      />
    </div>
    <div class="pwmat-introduce-container">
      <div class="pwmat-introduce-content">
        <div class="pwmat-introduce-content-title">
          <div class="pwmat-introduce-content-title-text">LS3DF简介</div>
          <div class="pwamt-introduce-line"></div>
        </div>
        <div class="pwmat-introduce-content-info">
          <p class="pwmat-introduce-content-info-text">
            LSEDF(线性标度三维分块算法)基于分而治之的思想，将大体系划分为许多小片段，每个小片段单独用DFT方法进行计算，然后将计算完的小片段组合拼接起来，从而得到大体系的电子结构性质。线性标度三维分块算法得以实施的基础是总能可以分为两部分：静电能和量子机械能（例如，动能和交换关联能）。其中静电能是远程的作用，所以必须对整体求解一个泊松方程，而计算昂贵的量子机械能是短程的作用，所以将整个系统切分成小片段，分别单独计算这些小片段的量子机械能，然后结合每个小片段DFT计算的能量，从而获得整个系统的能量。这其中需要解决的关键问题是如何组合拼接小片段，北京龙讯旷腾科技有限公司提出了一种新颖的拼接方案，可以通过特殊求和消除边界影响。在该计算方法中，一旦小片段尺寸被确定，以获得给定的数值精度，计算量与小片段数量成正比，因此，我们称其为线性标度三维分块方法。
          </p>
          <p class="pwmat-introduce-content-info-text">
            LS3DF用途广泛，可以用于晶界、位错、缺陷、非晶态或者实际器件研究。2020年,龙讯旷腾与中国科学院半导体研究所合作，在200个GPU的超算平台（Mstation
            Cluster，以下简称Mcluster）上实现了平面波精度的10万原子体系计算。2022年，龙讯旷腾与腾讯量子实验室、腾讯云高性能计算产品团队、盐城工学院石林教授团队联合攻关，成功实现了百万硅原子超大规模体系的平面波精度第一性原理计算。
          </p>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">相关下载</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
          >
            LS3DF安装包下载地址：<a href="//www.pwmat.com/ls3df-download"
              >//www.pwmat.com/ls3df-download</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PWMAT_RESOURCE } from "./../../helpers/consts";
export default {
  name: "companyIntroduce",
  data() {
    return {
      PWMAT_RESOURCE,
    };
  },
  methods: {
    toMSTATIONDownload() {
      this.$router.push({ name: "MSTATIONDownload" });
    },
    toPotentialDownload() {
      this.$router.push({ name: "PotentialDownload" });
    },
    toModuleDownload() {
      this.$router.push({ name: "ModuleDownload" });
    },
    toManual() {
      window.open(this.PWMAT_RESOURCE + "Manual.pdf");
    },
    toProchureBook() {
      window.open(this.PWMAT_RESOURCE + "prochure.pdf");
    },
    toProchureNewFunctions() {
      window.open(this.PWMAT_RESOURCE + "PWmat_2019_new_functions.pdf");
    },
  },
};
</script>

<style scoped>
.pwmat-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.pwmat-introduce-background {
  margin-top: 70px;
}
.pwmat-introduce-banner {
  overflow: hidden;
}
.pwmat-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.pwmat-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}
.pwmat-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.pwmat-introduce-content-title {
  padding-top: 50px;
}
.pwmat-introduce-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.pwmat-introduce-content-info {
  margin-top: 40px;
}
.pwmat-introduce-content-info-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.pwamt-introduce-line {
  height: 1px;
  background: rgba(240, 240, 240, 1);
  margin-top: 8px;
}
.pwmat-introduce-function {
  display: inline-block;
  padding-left: 80px;
  margin-bottom: 50px;
  width: 346px;
}
.pwmat-introduce-function-img {
  display: inline-block;
  vertical-align: top;
}
.pwmat-introduce-function-text {
  display: inline-block;
  vertical-align: top;
  margin-left: 23px;
}
.pwmat-introduce-function-name {
  font-size: 18px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  margin-bottom: 8px;
  margin-top: -6px;
}
.pwmat-introduce-function-desc {
  font-size: 14px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 20px;
}
.pwmat-inroduce-application {
  background: rgba(73, 145, 201, 0.1);
  padding: 24px 99px 27px 99px;
  margin-bottom: 50px;
}
.pwmat-inroduce-application-group-1 {
  width: 539px;
  display: inline-block;
}
.pwmat-inroduce-application-group-2 {
  width: 299px;
  display: inline-block;
}
.pwmat-inroduce-application-text {
  font-size: 16px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(79, 76, 77, 1);
  line-height: 38px;
  margin-bottom: 0;
}
@media screen and (max-width: 482px) {
  .pwmat-introduce-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .pwmat-introduce-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .pwmat-introduce-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
</style>
